import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { externalProductPestPacName } from '@sales-center/common'

export const useGetServiceNoteUrl = (
  locationId: number | string | undefined,
) => {
  const { externalProduct, clientUrl } = useSelector(selectCurrentUser)

  if (!locationId) return ''

  switch (externalProduct) {
    case externalProductPestPacName:
      return `${clientUrl}/notes/default.asp?LocationID=${locationId}`
    default:
      return ''
  }
}
